import { FC } from 'react';
import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import PrintHeader from 'modules/_shared/components/Headers/PrintHeader';

import NotarialRegistrationSection from './NotarialRegistrationSection';
import CommentsSection from './CommentsSection';

const OperationInfoSection: FC = () => {
  const { t } = useTranslate();
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );
  const societyLogo = actualSociety?.additional?.logo || '';
  const societyName = actualSociety?.name || '';

  return (
    <>
      <PrintHeader title={t('PrintHeaderTransactionsList')} />

      <div className="invoice-brand text-center d-flex justify-content-between">
        <div className="user-avatar lg bg-primary">
          {societyLogo ? (
            <img src={societyLogo} alt="Logo" />
          ) : (
            societyName && <span>{societyName.slice(0, 2).toUpperCase()}</span>
          )}
        </div>
      </div>

      <div className="invoice-head row">
        <CommentsSection />
        <NotarialRegistrationSection />
      </div>
    </>
  );
};

export default OperationInfoSection;
